import React, { useState} from 'react'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEnvelope } from '@fortawesome/free-regular-svg-icons'
import { faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons'
import me from '../assets/meDark.svg'
import logo from '../assets/logo.png'


const Home = () => {
    const [darkTheme, setDarkTheme] = useState(true)

    const themeChange = () => {
        setDarkTheme(!darkTheme)
    }

    return (
        <main id='homePage' className={darkTheme ? 'lightTheme' : 'darkTheme'}>
            <nav className='navbar display-flex'>
                <section className="logo">
                    <img src={logo} alt="logo" />
                </section>
                <section className={darkTheme ? 'nav-links light-links' : 'nav-links dark-links'}>
                    <ul>
                        <li className="nav-item"><Link href="/">Home</Link></li>
                        <li className="nav-item"><Link href="/">Portfolio</Link></li>
                        <li className="nav-item"><Link href="/">Services</Link></li>
                        <li className="nav-item"><Link href="/">Contact Me</Link></li>
                    </ul>
                </section>
                <section className="mode-toggler">
                    <label className="switch">
                        <input type="checkbox" onClick={themeChange} />
                        <span className="slider round"></span>
                    </label>
                </section>
            </nav>
            <section className={darkTheme ? 'under-dev' : 'dark-under-dev'}>
                <p>Website is under development</p>
            </section>
            <main className='display-flex flex-row landing-page'>
                <section className="profile display-flex flex-column">
                    <div className="img">
                        <img src={me} alt="" />
                    </div>
                    <div className={darkTheme ? 'light-links links display-flex' : 'links display-flex dark-links' }>
                        <Link className="link" target='_blank' to={'mailto:m.aashraf01@outlook.com?subject=ask%20about%20me'}><FontAwesomeIcon icon={faEnvelope} size='xl' /></Link>
                        <Link className="link" target='_blank' to={'https://github.com/aashraf09'}><FontAwesomeIcon icon={faGithub} size='xl' /></Link>
                        <Link className="link" target='_blank' to={'https://www.linkedin.com/in/abdullah-ashraf06/'}><FontAwesomeIcon icon={faLinkedinIn} size='xl' /></Link>
                    </div>
                </section>
                <section className="my-intro">
                    <h2 className="name">I'm Abdullah Ashraf</h2>
                    <h4 className="profession">MERN Stack Developer</h4>
                    <p className='my-description'>
                        I’ve been designing and developing web applications for the last 2 years. I’m expert in a variety of skills including Adobe XD and Figma for UI/ UX Designing and HTML, CSS, JavaScript, React JS, React Native, Node.JS, Express JS and MongoDB for development.
                    </p>
                    <div className="btn-group display-flex">
                        <button className={darkTheme ? 'btn btn-primary ' : 'btn btn-primary dark-links'} ><Link to={'https://github.com/aashraf09'} target='_blank'>See Portfolio </Link></button>
                        <button className={darkTheme ? 'btn light-btn' : 'btn dark-links'} ><Link to={'https://www.linkedin.com/in/abdullah-ashraf06/'} target='_blank'>Contact Me </Link></button>
                        
                    </div>
                </section>
            </main>
            {/* <div className="arrow-down">
                <FontAwesomeIcon icon={faArrowAltCircleDown} size='2xl' onClick={scrollUp} />
            </div>
            <section className="professional-skills">
                <div className="skills-icons">
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faHtml5} size='2xl' />
                        <p>HTML</p>
                    </div>
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faCss3Alt} size='2xl' />
                        <p>CSS</p>
                    </div>
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faJsSquare} size='2xl' />
                        <p>JavaScript</p>
                    </div>
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faReact} size='2xl' />
                        <p>React JS</p>
                    </div>
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faNodeJs} size='2xl' />
                        <p>Node.JS</p>
                    </div>
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faGitAlt} size='2xl' />
                        <p>Git</p>
                    </div>
                    <div className="skill-card">
                        <FontAwesomeIcon icon={faGithub} size='2xl' />
                        <p>GitHub</p>
                    </div>
                    <div className="skill-card">
                        <img src={mongodb} alt="" />
                        <p>MongoDB</p>
                    </div>
                    <div className="skill-card">
                        <img src={firebase} alt="" />
                        <p>MongoDB</p>
                    </div>                    
                </div>
            </section> */}
        </main>
    )
}

export default Home